import { de } from '@/i18n/de';
import { useAppStore } from '@/lib/store';
import { currentPhaseTotalSeconds } from '@/lib/phaseDuration';
import { AppShell } from '@/components/AppShell';
import { GameHeader } from '@/components/GameHeader';
import { Timer } from '@/components/Timer';

export function TieAnnounceScreen() {
  const view = useAppStore((s) => s.view);
  if (!view || view.lastResult?.type !== 'TIE') return null;

  const names = view.lastResult.playerIds
    .map((id) => view.players.find((player) => player.id === id)?.name ?? id)
    .join(' und ');

  return (
    <AppShell header={<GameHeader view={view} />}>
      <div className="mx-auto flex h-full max-w-md flex-col items-center justify-center gap-6 text-center">
        <p className="font-display text-3xl font-extrabold tracking-tight">{de.roundResult.tie}</p>
        <p className="text-fg-muted">{de.roundResult.tieHint(names)}</p>
        <p className="rounded-full bg-surface-2 px-4 py-1.5 text-sm font-medium text-fg-muted">
          {de.roundResult.tieCounter(view.tieCount, view.settings.maxTieRounds)}
        </p>
        <Timer
          endsAt={view.phaseEndsAt}
          totalSeconds={currentPhaseTotalSeconds(view)}
          size={120}
          label={de.common.timerTieBreaker}
        />
      </div>
    </AppShell>
  );
}
